export type MessageTypes =
  | 'AddTodo'
  | 'CheckTodo'
  | 'UncheckTodo'
  | 'NewConnection'
  | 'NewDisconnection';

export enum MessageNames {
  AddTodo = 'AddTodo',
  CheckTodo = 'CheckTodo',
  UncheckTodo = 'UncheckTodo',
  NewConnection = 'NewConnection',
  NewDisconnection = 'NewDisconnection',
}

export type TodoType = {
  id: string;
  isComplete: boolean;
  name: string;
  channelId?: string;
};

export const crudTodo = async ({
  channelId,
  type,
  message,
}: {
  channelId?: string;
  type: MessageTypes;
  message: any;
}) => {
  try {
    return await fetch('/.netlify/functions/crudTodos', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        channelId,
        type,
        message,
      }),
    });
  } catch (error) {
    console.error('Error sending message:', error);
  }
};
